module.exports = __webpack_public_path__ + "img/nodejs.f1e20005.png";